import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LandingPaginationDTO } from "../../bpg-common/services/data.services";
import { ConstantValues } from '../../bpg-common/models/bpg-constants';

import { Router } from '@angular/router';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { Location } from '@angular/common';

@Component({
  selector: 'manage-folder',
  templateUrl: './manage-folder.component.html',
  styleUrls: ['./manage-folder.component.css']
})
export class ManageFolderComponent implements OnInit {
  @ViewChild('myInput', { static: false })
  myInputVariable: ElementRef;
  LandingPaginationDTO: LandingPaginationDTO = new LandingPaginationDTO();
  landingDto: any;
  adminData: any;
  userList: any;
  name: any;
  email: any;
  workId: any;
  user: string = null;
  role: string = null;
  roleName: string = null;
  userFirstName: string = null;
  noDataFound: boolean;
  alertSuccess: boolean;
  alertFailure: boolean;
  deleteSuccess: boolean;
  errorMsg: any;
  msg1: string;
  method: string;
  param: any;
  loginData: any = JSON.parse(localStorage.getItem('loginData'));
  loginUserId: string;
  chapterId: number;
  createdBy: any = this.loginData.userId;
  createdDateTime: any;
  modifiedBy: any = this.loginData.userId;
  modifiedDateTime: any;
  userId: any;
  adminId: any = localStorage.getItem('adminId');
  numberOfElements: number;
  currentPage = 0;
  currentNumberOfElements = 10;
  totalPages = 0;
  roleList: any;
  tableShow: any;
  limit = 10;
  currentShowingElements = 10;
  searchKey: any;
  searchTerm: any;
  siteData: any;
  siteList: any;
  siteListSearch: any;
  selectedBpgsData: any;
  bpgList: any;
  bpgListSearch: any;
  selectedSiteId: any = Number(localStorage.getItem('userSiteId'));
  selectedBpgSearch: any;
  selectedErgId: any;
  selectedSite: any;
  selectedSiteSearch: any;

  siteAndPath: any;
  selectedBpg: any;
  allBpgIds: any;
  allSiteIds: any;
  landingData: any;
  loginUserAdminId: any = localStorage.getItem('adminId');
  tableresp: boolean;
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  loginDataDetails: any = JSON.parse(localStorage.getItem('loginData'));
  eventPicture = true;
  uploadFileName: string = null;
  uploadFileExtension = false;
  width: number;
  height: number;
  lbl: any;
  uploadedFile: string = null;
  action = "";
  fileExtensionError = false;
  fileSizeExtensionError = false;
  selectedFile: File = null;
  selectedFileName = "Upload < 500MB";
  fileName = "";
  fileExtension: any;
  fileSize: number;
  fileList: File[] = [];
  eventList: any;
  eventId: number;
  selectedSiteIdSearch: any = 0;
  selectedErgIdSearch: any = 0;
  page = 0;
  isFileUploded = false;
  documentsFolderList: any = null;
  selectAllConstant = 'Select All';
  chapterList: any;
  chapterIds: any;
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  awsUrls: any;
  galleryList: any;
  uploadFlag: any = "gallery";
  errorMsgUploadSave = false;
  leadAdminId: any = localStorage.getItem('leadAdminId');
  userAndRoleIdDTO: any;
  documentName: any;
  allowedExtensions: any = ["xls", "xlsx", "doc", "docx", "txt", "pdf"];
  typeList: any[] = [{ type: this.selectAllConstant }, { type: 'Document' }, { type: 'Image' }, { type: 'Video' }];
  filterType: any;
  folderName: any;
  siteName: any;
  bpgName: any;
  folderId: any = null;
  editAndSave = false;
  alertUpdateSuccess = false;
  errorMessage:any;
  firstEdit = false;
  isbpgAdmin = false;
  isbpgLeadAdmin = false;
  constructor(private readonly userService: SelfService,
    private readonly spinner: Ng4LoadingSpinnerService,
    private readonly bpgCommonService: BpgCommonService,
    private readonly bpgEventsService: BpgEventsService,
    private readonly router: Router,
    private readonly environment: EnvironmentConfiguration,
    private readonly location: Location) { }

  ngOnInit() {
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
              if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {

	this.router.navigate(['/log-out']);
      }
    }

    if (localStorage.getItem('logOutFlag') === "true") {
      this.router.navigate(['/log-out']);
    }


    localStorage.removeItem('searchedEventsCaledarItems');

    this.spinner.show();
    sessionStorage.removeItem("MembershipData");
    if (this.leadAdminId === 'true' && !this.isbpgAdmin) {
      localStorage.setItem('adminId', '2');

    }

    this.userAndRoleIdDTO = {
      userId: this.loginDataDetails['userId'],
      roleId: localStorage.getItem('adminId')

    }

    if(localStorage.getItem('isbpgAdmin') === 'true')
    {
      this.isbpgAdmin = true
}
if(localStorage.getItem('isbpgLeadAdmin') === 'true')
    {
      this.isbpgLeadAdmin = true
}
    if (this.loginUserAdminId === "2" || this.loginUserAdminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin) {
      this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(data => {
	this.chapterList = data;
	if (this.chapterList.length > 1) {
	  this.chapterList.unshift({ chapterId: 0, siteName: this.selectAllConstant, bpgName: '' });
	}
	for (let i = 0; i < this.chapterList.length; i++) {
	  if (i === 0) {
	    this.chapterIds = this.chapterList[i].chapterId;
	  }
	  else {
	    this.chapterIds = `${this.chapterIds},${this.chapterList[i].chapterId}`;
	  }
	}

	this.siteData = {
	  "filter": {
	    chapterId: this.chapterIds
	  },
	  "moduleId": 0,
	  "page": 0,
	  "presentRole": "",
	  "searchTerm": "",
	  "size": 0,
	  "sortDirection": "ASC",
	  "sortProperty": "",
	  "uid": ""
	}
	this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
	  this.siteList = data;
	  this.siteListSearch = data
	  //filter default site from sitelist
	  this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT');
	  this.siteListSearch = this.siteListSearch.filter(site => site.locationCode !== 'DFLT');

	  this.siteListSearch.unshift({ siteId: 0, siteName: this.selectAllConstant, bpgName: '' });

	  for (let i = 0; i < this.siteList.length; i++) {
	    if (i === 0) {
	      this.allSiteIds = this.siteList[i].siteId;
	    } else {
	      this.allSiteIds = `${this.allSiteIds}${this.siteList[i].siteId},`;
	    }
	  }
	  for (let i = 0; i < this.siteListSearch.length; i++) {
	    if (i === 0) {
	      this.allSiteIds = this.siteListSearch[i].siteId;
	    } else {
	      this.allSiteIds = `${this.allSiteIds}${this.siteListSearch[i].siteId},`;
	    }
	  }
	  this.getBpgList();
	  this.getBpgListSearch();


	});
      });

      this.getSiteName()
    }
    else if (this.loginUserAdminId === "1") {
      this.getSiteName()

      this.getSiteList();
      this.getBpgList();
      this.getBpgListSearch();
      this.getDocumentsFolderList();
    }


    this.landingDto = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }

    this.loginUserId = this.loginData.userId;

    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 500);

  }
  /** get site name in the dropdown for lead admin
    * @class ConfigureGalleryComponent
    * @method getSiteName
    */
  getSiteName() {
    this.selectedSite = this.loginData.site.siteName;
    this.siteName = this.selectedSite;
  }

  /** get site list in the dropdown
    * @class ConfigureGalleryComponent
    * @method getSiteList
    */
  getSiteList() {
    this.siteData = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }

    this.bpgCommonService.getSiteList(this.siteData).subscribe(data => {
      this.siteList = data;
      this.siteListSearch = data;
      //filter default site from sitelist
      this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT');
      this.siteListSearch = this.siteListSearch.filter(site => site.locationCode !== 'DFLT');

      this.siteListSearch.unshift({ siteId: 0, siteName: this.selectAllConstant, bpgName: '' });


      if (this.siteList != null || this.siteListSearch != null) {
	for (const s of this.siteList) {
	  if (s.siteId === this.selectedSiteId) {
	    this.selectedSite = s.siteName;
	  }
	}

	for (const s1 of this.siteListSearch) {
	  if (s1.siteId === this.selectedSiteId) {
	    this.selectedSite = s1.siteName;
	  }
	}

	for (let i = 0; i < this.siteList.length; i++) {
	  if (i === 0) {
	    this.allSiteIds = this.siteList[i].siteId;
	  } else {
	    this.allSiteIds = `${this.allSiteIds}${this.siteList[i].siteId},`;
	  }
	}

	for (let i = 0; i < this.siteListSearch.length; i++) {
	  if (i === 0) {
	    this.allSiteIds = this.siteListSearch[i].siteId;
	  } else {
	    this.allSiteIds = `${this.allSiteIds}${this.siteListSearch[i].siteId},`;
	  }
	}

      }
    });
  }

  /** get gallery list
   * @class ConfigureGalleryComponent
   * @method getChapterGalleryList
   */
  public getDocumentsFolderList() {
    this.spinner.show();
    if (this.selectedSiteIdSearch === 0) {
      this.selectedSiteIdSearch = this.allSiteIds;
    }
    if (this.selectedErgIdSearch === 0) {
      this.selectedErgIdSearch = this.allBpgIds;
    }

    this.landingData = {
      "filter": { "siteId": this.selectedSiteIdSearch, "bpgId": this.selectedErgIdSearch },
      "moduleId": 0,
      "page": this.page,
      "presentRole": "",
      "searchTerm": "",
      "size": this.limit,
      "sortDirection": "DESC",
      "sortProperty": "created_date_time",
      "uid": ""
    }
    this.userService.getDocumentsFolderList(this.landingData).subscribe(data => {
      this.documentsFolderList = data.content;
      this.numberOfElements = data.totalElements;
      this.spinner.hide();
      if (this.documentsFolderList.length === 0) {
	this.noDataFound = true;
	this.tableShow = false;

      } else {
	this.noDataFound = false;
	this.tableShow = true;
      }
    });
  }


  /** get bpg list in the dropdown
    * @class ConfigureGalleryComponent
    * @method getBpgList
    */
  getBpgList() {
    this.selectedBpgsData =
    {
      "filter": {
	"siteId": this.selectedSiteId,
	"adminId": this.loginUserAdminId,
	"userId": this.createdBy
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
      this.bpgList = data;
      if (this.bpgList.length === 0) {
	
	this.bpgList.unshift({ bpgId: 0, bpgName: 'No Data found' });
      }



      if (this.bpgList != null) {

	for (const bpg of this.bpgList) {
	  if (bpg.bpgId === this.selectedErgId) {
	    this.selectedBpg = bpg.bpgName;
	  }
	}

	for (let i = 0; i < this.bpgList.length; i++) {
	  if (i === 0) {
	    this.allBpgIds = this.bpgList[i].bpgId;
	  } else {
	    this.allBpgIds = `${this.allBpgIds}${this.bpgList[i].bpgId},`;
	  }
	}
      }

    });
  }


  getBpgListSearch() {
    this.selectedBpgsData =
    {
      "filter": {
	"siteId": this.selectedSiteIdSearch,
	"adminId": this.loginUserAdminId,
	"userId": this.createdBy
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""
    }
    this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(data => {
      this.bpgListSearch = data;

      if (this.bpgListSearch != null) {
	this.bpgListSearch.unshift({ bpgId: 0, bpgName: this.selectAllConstant });

	for (const bpgList of this.bpgListSearch) {
	  if (bpgList.bpgId === this.selectedErgId) {
	    this.selectedBpg = bpgList.bpgName;
	  }
	}


	for (let i = 0; i < this.bpgListSearch.length; i++) {
	  if (i === 0) {
	    this.allBpgIds = this.bpgListSearch[i].bpgId;
	  } else {
	    this.allBpgIds = `${this.allBpgIds}${this.bpgListSearch[i].bpgId},`;
	  }
	}
	if (this.loginUserAdminId === "2" || this.loginUserAdminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin) {

	  this.getDocumentsFolderList();
	}
      }


    });
  }

  /** get chapter id
  * @class ConfigureGalleryComponent
  * @method getChapterIds
  */
  getChapterIds() {
    this.landingData = {
      "filter": {
	"bpgId": this.selectedErgId,
	"siteId": this.selectedSiteId
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string"
    }
    this.userService.getChapterByBpg(this.landingData).subscribe(data => {
      if (data != null) {
	for (const d of data) {
	  this.chapterId = d;
	}
      }
    });
  }


  /** For site change from site list
     * @class ConfigureGalleryComponent
     * @method siteChange
     * @returns Promise
     */
  siteChange(event) {
    this.selectedErgId = null;
    this.selectedBpg = null;
    this.userFirstName = null;
    this.userId = null;
    this.selectedSiteId = event.siteId;
    this.bpgList = [];
    this.siteName = event.siteName;
    this.getBpgList();


  }
  /** For bpg change from bpg list
    * @class ConfigureGalleryComponent
    * @method bpgChange
    * @returns Promise
    */

  bpgChange(event) {
    this.selectedErgId = null;
    this.userFirstName = null;
    this.userId = null;
    this.selectedErgId = event.bpgId;
    this.getChapterIds();

  }

  /** checks if word exists in array
   * @class ConfigureGalleryComponent
   * @method isInArray
   */
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }


  /** For adding 365 days to current day
* @class ConfigureGalleryComponent
* @method addDays
* @params Date, number
*/
  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }


  /** to submit resource
   * @class ConfigureGalleryComponent
   * @method onChapterGallerySubmit
   */
  public onManageFolderSubmit() {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.alertUpdateSuccess = false;
    this.timeOutError = false;
    this.deleteSuccess = false;

    this.method = "addDocumentsFolder";
    this.param = '';
    if(this.editAndSave){
    this.msg1 = " Are you sure you want to update ? ";
  }else{
    this.msg1 = " Are you sure you want to save ? ";
  }

  }


  /** to add new admin
    * @class ConfigureGalleryComponent
    * @method addGallery
    */
  public addDocumentsFolder() {
    localStorage.setItem('siteId',this.selectedSiteId);
    localStorage.setItem('bpgId',this.selectedErgId);
    localStorage.setItem("siteName",this.siteName);
    this.alertSuccess = false;
    this.alertFailure = false;
    this.timeOutError = false;
    this.deleteSuccess = false;
    this.alertUpdateSuccess = false;
    this.modifiedDateTime = new Date();
    let folderData = null;
    this.spinner.show();

    if (this.folderId != null) {
      folderData = {
	"folderId": this.folderId,
	"createdBy": this.createdBy,
	"createdDateTime": this.createdDateTime,
	"isActive": true,
	"modifiedBy": this.modifiedBy,
	"modifiedDateTime": this.modifiedDateTime,
	"bpgId": this.selectedErgId,
	"siteId": this.selectedSiteId,
	"folderName": this.folderName,
	"chapterId": this.chapterId
      }
    } else {
      this.createdDateTime = new Date();
      folderData = {
	"createdBy": this.createdBy,
	"createdDateTime": this.createdDateTime,
	"isActive": true,
	"modifiedBy": this.modifiedBy,
	"modifiedDateTime": this.modifiedDateTime,
	"bpgId": this.selectedErgId,
	"siteId": this.selectedSiteId,
	"folderName": this.folderName
      }
    }

    this.userService.addDocumentsFolder(folderData).subscribe(data => {
      if(data.body.message){
	this.spinner.hide();
	this.errorMsg = data.body.message;
	this.alertFailure = true;
	setTimeout(() => {
	  window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
	}, 200);
	return;
      }

      if(this.editAndSave){
	this.alertUpdateSuccess = true;
      }else{
      this.alertSuccess = true;
    }
      this.alertFailure = false;
      this.getDocumentsFolderList();
      this.spinner.hide();
      setTimeout(() => {
        this.resetGallery()
      }, 1500);
      setTimeout(() => {
	window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }, 200);
    }, err => {
      if (err.value.statusText === ConstantValues.unknownError) {
	this.alertFailure = true;
	this.alertSuccess = false;
      }
    })

  }


  /** For filtering data by current page
   * @class ConfigureGalleryComponent
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {
    this.page = event - 1;
    this.currentPage = event;

    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.getDocumentsFolderList();
  }

  /** Confirm on reset
    * @class ConfigureGalleryComponent
    * @method resetGallery
    */
  resetGallery() {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 200);
    this.folderId = null;
    this.folderName = null;
    this.editAndSave = false;
    this.selectedBpg = null;
    this.selectedErgId = null;
    this.selectedErgIdSearch = null;
    this.selectedSiteIdSearch = null;
    this.searchKey = null;
    this.LandingPaginationDTO.searchTerm = null;
    this.selectedFileName = "Upload < 500MB";
    this.selectedSiteId = localStorage.getItem('userSiteId');
    this.eventId = null;
    this.deleteSuccess = false;
    this.fileExtensionError = false;
    this.fileSizeExtensionError = false;
    this.alertSuccess = false;
    this.alertFailure = false;
    this.alertUpdateSuccess = false;
    this.timeOutError = false;
    this.selectedFile = null;
    this.isFileUploded = false;
    this.selectedBpgSearch = null;
    this.selectedSiteSearch = null;
    this.errorMsgUploadSave = false;
    this.documentName = "";
    this.filterType = null;
    this.selectedSite = this.loginData.site.siteName;
    this.eventPicture = true;
    this.firstEdit = false;

    if (this.loginUserAdminId === "3" || this.loginUserAdminId === "2" || this.isbpgAdmin || this.isbpgLeadAdmin) {
      this.selectedSiteIdSearch = 0;
      this.selectedErgIdSearch = 0;
      this.getBpgListSearch();
    }
    this.getDocumentsFolderList();
    this.getBpgList();
  }

  public updateDocument(data,i){
    if(this.firstEdit === false){
      this.firstEdit = true;
      this.editFolder(data);
    }else{
    document.getElementById('edit'+i).setAttribute('data-toggle','modal');
    document.getElementById('edit'+i).setAttribute('data-target','#myModal');
    this.method = "editFolder";
    this.param = data;
    this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    }
  }


  /** For site change from site list
   * @class ConfigureGalleryComponent
   * @method siteChangeSearch
   * @returns Promise
   */
  siteChangeSearch(event) {

    this.selectedSiteIdSearch = event.siteId;
    this.getBpgListSearch()
  }
  /** For bpg change from bpg list
    * @class ConfigureGalleryComponent
    * @method bpgChangeSearch
    * @returns Promise
    */

  bpgChangeSearch(event) {

    this.selectedErgIdSearch = event.bpgId;

  }

  /** to Delete gallery
* @class ConfigureGalleryComponent
* @method deleteGallery
*/
  deleteDocumentsFolder(folderId) {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.timeOutError = false;
    this.deleteSuccess = false;
    this.alertUpdateSuccess = false;
    this.spinner.show();
    this.userService.deleteDocumentsFolder(folderId).subscribe(_data => {
      this.spinner.hide();
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      this.deleteSuccess = true;
      this.alertSuccess = false;
      this.errorMsgUploadSave = false;
      if (this.documentsFolderList.length === 1 && this.numberOfElements > 10) {
	this.currentPage = 0;
	this.page = 0;
	this.currentShowingElements = 10

      }

      this.getDocumentsFolderList();
    });
  }


  /** confirmation to delete gallery
* @class ConfigureGalleryComponent
* @method deleteGalleryConfirmation
*/
  public deleteFolderConfirmation(id) {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.alertUpdateSuccess = false;
    this.timeOutError = false;
    this.deleteSuccess = false;

    this.method = "deleteDocumentsFolder";
    this.param = id;
    this.msg1 = "  Are you sure you want to delete ? ";
  }

  downloadDocument(urls, i) {
    const extension = urls.substring(urls.lastIndexOf('.') + 1);
    const link = document.getElementById('downloadFiles' + i);
    link.setAttribute('href', urls);
    link.setAttribute('download', urls);
    if (extension.includes('mp4')) {
      link.setAttribute('target', '_blank');
    }
  }


  /** to reset resource
   * @class ConfigureGalleryComponent
   * @method resetClick
   */
  resetClick() {
    this.method = "resetGallery";
    this.param = '';
    this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
  }

  public getDocumentsFolderListForSearch() {
    this.page = 0;
    this.currentPage = 1;
    this.getDocumentsFolderList();

  }

  editFolder(data) {
    this.alertSuccess = false;
    this.alertFailure = false;
    this.alertUpdateSuccess = false;
    this.timeOutError = false;
    this.deleteSuccess = false;


    this.editAndSave = true;
    this.folderId = data.folderId;
    this.folderName = data.folderName;
    this.chapterId = data.chapterId;
    this.selectedErgId = data.bpgId;
    this.selectedSiteId = data.siteId;
    this.siteName = data.siteName;
    this.bpgName = data.bpgName;
    this.selectedSite = this.siteName;
    this.selectedBpg = this.bpgName;
    this.createdDateTime = data.createdDateTime;
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }


  /** to select cancel
    * @class CreateAndEditExpenseClaimComponent
    * @method cancelClick
    */
  cancelClick() {
    this.method = "navigate";
    this.msg1 = " Are you sure you want to leave this page ? Changes you made may not be saved.";
    this.param = "";
  }

  navigate() {
    this.location.back();
    window.scrollTo(0, 0);
  }




}







